// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__jVvSK","tiny":"Avatar_tiny__em0+o","small":"Avatar_small__cIJyU","half":"Avatar_half__N1zBQ","fixed_height":"Avatar_fixed_height__HOLfK"};